import vStepperLabel from './StepperLabel.vue';
import vStepperContent from './StepperContent.vue';

export { vStepperLabel, vStepperContent };



// WEBPACK FOOTER //
// ./src/appComponents/components/Stepper/index.js